import React from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {compose} from 'react-apollo';
import MultiUnitTitle from './MultiUnitTitle';

const getMinPriceLabel = (intl, minPriceData) => {
    return minPriceData.price && (minPriceData.isPriceRange
        ? intl.formatMessage(
            {
                id: 'multipleUnitsFrom',
                defaultMessage: 'from {price} per night'
            },
            {
                price: `<span class="MultiUnitDropdown__header_min-price-value">${minPriceData.price}</span>`
            }
        )
        : intl.formatMessage(
            {
                id: 'multipleUnitsPerNight',
                defaultMessage: '{price} per night'
            },
            {
                price: `<span class="MultiUnitDropdown__header_min-price-value">${minPriceData.price}</span>`
            }
        ));
};

const MultiUnitTypesSummary = ({intl, propertyName, resultCount, loading, minPriceData}) => {
    return (
        <div className="MultiUnitDropdown__header micro">
            <MultiUnitTitle headline={propertyName} />
            {loading && (
                <div className="MultiUnitDropdown__header-row--loading">
                    <div className="MultiUnit__header-skeleton" />
                    <div className="MultiUnit__header-skeleton" />
                </div>
            )}

            {!!resultCount && resultCount > 0 && (
                <div className="MultiUnitDropdown__header_description">
                    <span
                        dangerouslySetInnerHTML={{__html: getMinPriceLabel(intl, minPriceData)}}
                        className="MultiUnitDropdown__header_min-price-label"
                    />
                    <FormattedMessage
                        id="multipleUnitsTypes"
                        defaultMessage="{count, plural, one {{count} unit type} few {{count} unit types} many {{count} unit types} other {{count} unit types}} available"
                        values={{
                            count: resultCount
                        }}
                    >
                        {(txt) => (
                            <span className="MultiUnitDropdown__header_resultcount">{txt}</span>
                        )}
                    </FormattedMessage>
                </div>
            )}
        </div>
    );
};

export default compose(injectIntl)(MultiUnitTypesSummary);
